namespace GeniuzPOS.InventoryReport {
    export interface IcReport06Form {
        SkuCode: Serenity.StringEditor;
        SkuDesc: Serenity.StringEditor;
        SkuEnDesc: Serenity.StringEditor;
        QtyOnhand: Serenity.DecimalEditor;
        MinStockQty: Serenity.DecimalEditor;
        MaxStockQty: Serenity.DecimalEditor;
        CatCode: Serenity.StringEditor;
        CatName: Serenity.StringEditor;
        SubCat1Code: Serenity.StringEditor;
        SubCat1Name: Serenity.StringEditor;
        SubCat2Code: Serenity.StringEditor;
        SubCat2Name: Serenity.StringEditor;
        BrandCode: Serenity.StringEditor;
        BrandName: Serenity.StringEditor;
        StyleId: Serenity.StringEditor;
        StyleName: Serenity.StringEditor;
        ColorId: Serenity.StringEditor;
        ColorName: Serenity.StringEditor;
        SizeId: Serenity.StringEditor;
        SizeName: Serenity.StringEditor;
        TasteId: Serenity.StringEditor;
        TasteName: Serenity.StringEditor;
        MatTypeId: Serenity.StringEditor;
        MatTypeName: Serenity.StringEditor;
        SupplId: Serenity.StringEditor;
        SupplName: Serenity.StringEditor;
        StockFg: Serenity.IntegerEditor;
        ConsignFg: Serenity.IntegerEditor;
    }

    export class IcReport06Form extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReport06';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcReport06Form.init)  {
                IcReport06Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(IcReport06Form, [
                    'SkuCode', w0,
                    'SkuDesc', w0,
                    'SkuEnDesc', w0,
                    'QtyOnhand', w1,
                    'MinStockQty', w1,
                    'MaxStockQty', w1,
                    'CatCode', w0,
                    'CatName', w0,
                    'SubCat1Code', w0,
                    'SubCat1Name', w0,
                    'SubCat2Code', w0,
                    'SubCat2Name', w0,
                    'BrandCode', w0,
                    'BrandName', w0,
                    'StyleId', w0,
                    'StyleName', w0,
                    'ColorId', w0,
                    'ColorName', w0,
                    'SizeId', w0,
                    'SizeName', w0,
                    'TasteId', w0,
                    'TasteName', w0,
                    'MatTypeId', w0,
                    'MatTypeName', w0,
                    'SupplId', w0,
                    'SupplName', w0,
                    'StockFg', w2,
                    'ConsignFg', w2
                ]);
            }
        }
    }
}
